import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ServiceContractor } from '../../_modules/case-statistics/cas-settings/model/serviceContractor.model';
import { Contractor } from './../../_modules/case-statistics/cas-separated/model/contractor.model';
import { BsGuiSettings } from './../model/bs-gui-settings';
import { BusinessSubject } from './../model/business-subject';
import { MbContractor } from './../model/mb-contractor';
import { Module } from './../model/module.model';
import { ApiUrlService } from './api-url.service';
import { HttpClientService } from './http-client.service';

@Injectable({
    providedIn: 'root',
})
export class CommonService {
    private httpClient = inject(HttpClientService);
    private helperUrl = inject(ApiUrlService);

    public getBSGuiSettings(bsid: number): Observable<BsGuiSettings> {
        return this.httpClient.get(
            this.helperUrl.getSessionUrl(`bs/${bsid}/settings`, this.helperUrl.getAssistanceUrl(2, `app/settings/bs/${bsid}`)),
        );
    }
    public getBSModules(bsid: number): Observable<Module[]> {
        return this.httpClient.get(this.helperUrl.getSessionUrl(`bs/${bsid}/modules`, this.helperUrl.getAssistanceUrl(3, `bs/${bsid}/modules`)));
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO Ignored with eslint-interactive on 2026-02-26
    public getContractorGuiSettings(cid: number): Observable<any> {
        return this.httpClient.get(
            this.helperUrl.getSessionUrl(`contractors/${cid}/settings`, this.helperUrl.getEambulantaApi(2, `app/settings/contractor/${cid}`)),
        );
    }

    public getContractors(bsid: number, bpiType: string = ''): Observable<Contractor[]> {
        const networkPath = bpiType ? `bs/${bsid}/bpis/${bpiType}/contractors` : `bs/${bsid}/contractors`;
        return this.httpClient.get(
            this.helperUrl.getContractorsUrl(networkPath, this.helperUrl.getNetworkUrl(1, `bs/${bsid}/contractors/${bpiType}`)),
        );
    }

    public getContractorConnectedBs(bsid: number, cId: string): Observable<BusinessSubject[]> {
        return this.httpClient.get(
            this.helperUrl.getContractorsUrl(
                `bs/${bsid}/contractors/${cId}/business-subjects`,
                this.helperUrl.getNetworkUrl(1, `bs/${bsid}/contractors/${cId}/bslist`),
            ),
        );
    }

    public getExternalContractorData(bsId: number, externalId: string): Observable<Contractor> {
        return this.httpClient.get(
            this.helperUrl.getContractorsUrl(
                `bs/${bsId}/contractors/${externalId}/details`,
                this.helperUrl.getNetworkUrl(1, `bs/${bsId}/contractors/${externalId}/info-data`),
            ),
        );
    }

    public getContractorModules(contractorId: number): Observable<Module[]> {
        return this.httpClient.get(
            this.helperUrl.getSessionUrl(
                `contractors/${contractorId}/modules`,
                this.helperUrl.getRootApiUrl(3, `eav2/settings/api/contractors/${contractorId}/modules`),
            ),
        );
    }

    public getContractorUserRoles(contractorid: number): Observable<string[]> {
        return this.httpClient.get(
            this.helperUrl.getSessionUrl(`users/me/contractors/${contractorid}/roles`, this.helperUrl.getEambulantaApi(2, `roles/${contractorid}`)),
        );
    }

    public getMBMaskedContractors(bsId: number): Observable<MbContractor[]> {
        return this.httpClient.get(this.helperUrl.getAssistanceUrl(2, `bs/${bsId}/networkinfo`));
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO Ignored with eslint-interactive on 2026-02-26
    public changePwd(data: any): Observable<any> {
        return this.httpClient.post(this.helperUrl.getAssistanceUrl(2) + 'user/pwd', data);
    }

    public getContractorsServicesSetup(contractorid: string, bpitype: string): Observable<ServiceContractor[]> {
        return this.httpClient.get(
            // 'http://localhost:8092/booking/v2/assistance/api/services/manage/ddd96ff5-a36d-48c8-8d21-41a318d5dc07/type/SEPARATED',
            this.helperUrl.getAssistanceUrl(2) + `services/manage/${contractorid}/type/${bpitype}`,
        );
    }
}
